module.exports = __webpack_public_path__ + "static/media/badge_background.4a2423f6.png";